export default __webpack_public_path__ + "static/media/blush_side_logo_colored.68f3050f.svg";